import type { QuickAddFormProps } from '../types'

export const flattenSelectedOptions = (
  selectedOptions: QuickAddFormProps['variants'][number]['selectedOptions'],
) => selectedOptions.map(({ value }) => value)
